<template>
    <div class="form-container">
        <span v-if="formId === null || subject === null">
            <FormStartComponent :fixed-subject="initialSubject" @open-form="handleOpenForm" />
        </span>
        <span v-else>
            <DynamicFormRenderer ref="dynamicFormRenderer" :formId="formId" :subject="subject" :_responseId="responseId" @exit="handleExit" @form-submitted="handleFormSubmitted" />
        </span>
    </div>
</template>

<script>
    import FormStartComponent from "./FormStartComponent.vue";
    import DynamicFormRenderer from "./DynamicFormRenderer.vue";

    export default {
        name: "DynamicFormComponent",
        emits: ["exit", "form-submitted"],
        components: { FormStartComponent, DynamicFormRenderer },
        props: {
            initialSubject: {
                type: [Object, null],
                default: null,
            }
        },
        data() {
            return {
                formId: null,
                subject: this.initialSubject,
                responseId: null,
            }
        },
        methods: {
            handleBeforeRouteLeave(next) {
                if (this.formId === null || this.subject === null) {
                    next();
                } else {
                    const formComp = this.$refs.dynamicFormRenderer;
                    if (formComp && typeof formComp.handleBeforeRouteLeave === 'function') {
                        formComp.handleBeforeRouteLeave(next);
                    } else {
                        next();
                    }
                }
            },
            handleOpenForm({ formId, subject, responseId }) {
                this.formId = formId;
                this.subject = subject;
                this.responseId = responseId;
            },
            handleExit() {
                this.formId = null;
                this.subject = this.initialSubject;
                this.responseId = null;
                this.$emit("exit");
            },
            handleFormSubmitted() {
                this.formId = null;
                this.subject = this.initialSubject;
                this.responseId = null;
                this.$emit("form-submitted");
            }
        }
    }
</script>
